import ReactDOM from 'react-dom';
import preloaded from '../../src/preloaded.js';
import RecruitingFilterBtn from '../../src/recrutingFilter/RecruitingFilterBtn';

const el = document.getElementById('FilterBtn');

const { filterPreload } = preloaded;

if (el) {
  ReactDOM.render(
  <RecruitingFilterBtn
    initialFilters={filterPreload.filters}
    actionUrl={preloaded.action_url}
    allGradYears={filterPreload.all_grad_years}
    allSports={filterPreload.all_sports}
    allPositions={filterPreload.all_positions}
  />
  , el);
}
